<style>
	.middle-box{
		border-left: 1px solid rgba(0, 0, 0, 0.12);
		border-right: 1px solid rgba(0, 0, 0, 0.12);
	}
	.middle-box-top{
		border-bottom: 1px solid rgba(0, 0, 0, 0.12);
	}
	.middle-box-bottom-1, .middle-box-bottom-2, .middle-box-bottom-3{
		display: flex;
		height: 100px;
		align-items: center;
		justify-content: center;
		font-weight: bold;
	}
	.middle-box-bottom a{
		text-decoration: none;
		color: black!important;
	}
	.middle-box-bottom a:hover{
		text-decoration: underline;
	}
	.middle-box-bottom-1{
		background-color: #de5d122e;
	}
	.middle-box-bottom-2{
		background-color: #0037ff4d;
	}
	.middle-box-bottom-3{
		background-color: #d0a711a1;
	}
	.details-label{
		font-weight: bold;
	}
	.top-border{
		border-top: solid 1px rgba(0, 0, 0, 0.12);
	}
	.double-check-text{
		font-weight: 600;
    font-size: 10px;
    background: yellow;
    width: 100%;
    text-align: center;
	}
</style>

<template>
  <v-app>
    <v-content>
      <router-view />
    </v-content>
  </v-app>
</template>

<script>


export default {
  name: 'App',
  data: () => ({
  }),
};
</script>
